import { atom } from "recoil";

export const actionProfitRowsState = atom({
  key: "actionProfitRowsState",
  default: [],
});
